import styled from "styled-components"
import UIButton from "@irati/ui/src/Button"

export const Activate = styled(UIButton)`
  margin-top: 30px;
`
